const common = {
  message: {
    failureMessageUpload: 'Es ist ein Fehler aufgetreten, versuchen Sie es bitte erneut'
  }
};

export default common;
